// extracted by mini-css-extract-plugin
module.exports = {"root":"ForgotPasswordSuccessModal_root__2ua-s","message":"ForgotPasswordSuccessModal_message__2Vexo"};